import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.svg";
import saveAddIcon from "../assets/saveAdd.svg";

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="border-t border-[#E6EAF0] bg-[#F5F7FB] text-[#24303A] dark:border-slate-800 dark:bg-slate-950 dark:text-slate-100">
      {/* Section above footer */}
      <div className="w-full max-w-full pt-6">
        <div className="flex flex-col gap-4 bg-[#24303A] px-5 py-8 text-white shadow-sm sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center" aria-hidden="true">
              <img src={saveAddIcon} alt="" className="h-10 w-10 object-contain" aria-hidden />
            </span>
            <p className="text-[18px] font-bold tracking-wide sm:text-[20px]">
              Invite your friends and earn exciting rewards! reach out to our team to participate
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3 sm:justify-end sm:pr-20">
            {/* <button
              type="button"
              onClick={() => navigate("/features")}
              className="rounded-full bg-white/10 px-6 py-1.5 text-[16px] font-bold text-white"
            >
              Compare Prices
            </button> */}
            <button
              type="button"
              onClick={() => {
                window.location.href = "mailto:admin@femtyz.com";
              }}
              className="rounded-full bg-[#7352C7] px-6 py-2 text-sm font-semibold text-white hover:bg-[#5f43b2] transition"
            >
              admin@femtyz.com
            </button>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-full px-4 py-10 md:px-6">
        <div className="grid gap-10 sm:grid-cols-3 md:gap-8">
          <div className="max-w-md">
            <div className="flex items-start gap-3">
              <img src={logo} alt="FEMTYZ" className="h-10 w-auto" />
            </div>
            <p className="mt-4 text-[16px] font-normal leading-5 text-[#6E7B86] dark:text-slate-400">
              FEMTYZ – Fintech for Groceries
            </p>
            <p className="mt-1 text-[16px] font-normal leading-5 text-[#6E7B86] dark:text-slate-400">
              Smarter shopping. Real-time price intelligence. Better savings, every shop.
            </p>
            <p className="mt-4 text-[16px] font-normal leading-5 text-[#6E7B86] dark:text-slate-400">
              Compare prices, optimise your basket, and stay in control of your grocery spend – all in one place.
            </p>
          </div>

          <div className="justify-start md:justify-self-center">
            <h3 className="text-[18px] font-semibold text-[#24303A] dark:text-slate-100">
              Explore FEMTYZ
            </h3>
            <nav className="mt-4 space-y-3 text-[16px] font-medium">
              <Link className="block text-[#24303A] dark:text-slate-100"
                to="/features"
              >
                Compare Prices
              </Link>
              <Link
                className="block text-[#24303A] dark:text-slate-100"
                to="/settings?tab=grocery"
              >
                My Grocery List
              </Link>
              <Link
                className="block text-[#24303A] dark:text-slate-100"
                to="/settings?tab=grocery"
              >
                Smart Basket
              </Link>
              <Link className="block text-[#24303A] dark:text-slate-100"
                to="/top-deals"
              >
                Top Deals
              </Link>
              <Link className="block text-[#24303A] dark:text-slate-100" to="/contact">
                Help &amp; Support
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="text-[18px] font-semibold text-[#24303A] dark:text-slate-100">
              Company &amp; Trust
            </h3>
            <nav className="mt-4 space-y-3 text-[16px] font-medium">
              <Link className="block text-[#24303A]" to="/about">
                About FEMTYZ
              </Link>
              <Link className="block text-[#24303A]" to="/faq">
                How It Works
              </Link>
              <Link className="block text-[#24303A]" to="/data-pricing-transparency">
                Data &amp; Pricing Transparency
              </Link>
              <Link className="block text-[#24303A]" to="/privacy-policy">
                Privacy Policy
              </Link>
              <Link className="block text-[#24303A]" to="/terms">
                Terms of Use
              </Link>
            </nav>
          </div>
        </div>
      </div>

      <div className="bg-[#F5F7FB] dark:border-slate-800 dark:bg-slate-900/40">
        <div className="mx-auto w-full max-w-full px-4 py-4 md:px-6">
          <h4 className="text-[18px] font-semibold text-[#24303A] dark:text-slate-100">
            Compliance / Disclaimer
          </h4>
          <p className="mt-2 max-w-5xl text-[16px] font-normal leading-5 text-[#6E7B86] dark:text-slate-400">
            Prices and availability are updated regularly but may vary in-store. FEMTYZ provides comparison insights and does not sell products directly.
          </p>
        </div>
      </div>

      <div className="border-t-2 mt-4 border-[#7352C7] bg-[#FFFFFF]">
        <div className="mx-auto max-w-6xl px-4 py-4 text-center text-[16px] text-[#6E7B86] dark:text-slate-400 md:px-6">
          Copyright © {new Date().getFullYear()} | Built for everyday households. Powered by smart data.
        </div>
      </div>
    </footer>
  );
}

export default Footer;